import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import FormContact from "../components/FormContact";
import MessageSuccess from "../components/MessageSuccess";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

function App(props) {
  const { location } = props;

  const [idSac, setIdSac] = useState(undefined);
  const [responseForm, setResponseForm] = useState({});
  const [isCheckCookie, setIsCheckCookie] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const urlParams = queryString.parse(location.search);
    if (urlParams.allAccess) {
      localStorage.removeItem("idSac");
      localStorage.removeItem("response");
      document.cookie = "new_form= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    }
    setIsCheckCookie(true);

    const date = new Date();
    setCurrentTime(date.getTime());
  }, [location.search]);

  useEffect(() => {
    if (isCheckCookie) {
      let found = false;
      let splitCookies = document.cookie.replace(/ /g, "");
      splitCookies = splitCookies.split(";");
      splitCookies.forEach((cookie) => {
        const splitCookie = cookie.split("=");
        if (splitCookie[0] === "new_form") {
          found = true;
          setIdSac(localStorage.getItem("idSac"));
          setResponseForm(localStorage.getItem("response"));
        }
      });

      if (!found) {
        localStorage.removeItem("idSac");
        setIdSac(null);
        localStorage.removeItem("response");
        setResponseForm(null);
      }
    }
  }, [isCheckCookie]);

  if (idSac === undefined) return null;

  return (
    <div className="App">
      <Header />
      {currentTime > parseInt(localStorage.currentDate) + 600 ? (
        <FormContact setIdSac={setIdSac} setResponseForm={setResponseForm} />
      ) : !responseForm ? (
        <FormContact setIdSac={setIdSac} setResponseForm={setResponseForm} />
      ) : (
        !!responseForm?.success && (
          <MessageSuccess idSac={responseForm?.id_sac} />
        )
      )}
    </div>
  );
}

export default withRouter(App);
